import { NudgeTypes } from './constants';
export function isNudgeType(maybe) {
  return Object.values(NudgeTypes).includes(maybe);
}